function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, ref, computed, reactive, watch, nextTick, // watch,
getCurrentInstance } from "vue";
import { definePropType } from "@types-vue/props";
import { pushCreative } from "@/api/creative/push";
import { getCommonConfig } from "@/api/common";
import ChannelSetting from "./channel-setting.vue";
import PackageSetting from "../version-download/package-setting.vue";
import PackageManager from "@/views/creative/components/package-manager.vue";
import { Unity, Mintegral, fmtSize, Applovin, IronSource, Xmp } from "./shared";
import { PtBusinessType } from "./config";
import { MaterialMakeFrom } from "@pt/enums/push";
import { Message } from "element-ui";
import { locationToPointManagement } from "@pt/components/version-download/index";
import VersionName from "@pt/components/version-download/version-name.vue";
import PlayableName from "./playable-name.vue";
export default defineComponent({
    name: "CommonPushDialog",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        objectIds: {
            type: definePropType([
                Array,
                String,
                Number, 
            ]),
            default: function() {
                return [];
            }
        },
        // 是否显示下载剩余量
        showDownloadBalance: {
            type: Boolean,
            default: false
        },
        isPlayablePush: {
            type: Boolean,
            default: true
        },
        // 是否允许包体控制
        enablePackageQuality: {
            type: Boolean,
            default: false
        },
        resStatus: {
            type: definePropType(Object),
            default: function() {
                return {
                    audio: 1,
                    image: 0,
                    video: 0
                };
            }
        },
        allowedChannels: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        projectCountRequest: {
            type: definePropType(Function)
        },
        packRequest: {
            type: definePropType(Function)
        },
        onBeforePush: {
            type: definePropType(Function)
        },
        mwsName: {
            type: String
        },
        versionData: {
            type: definePropType(Object)
        },
        materialNameOptions: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        // 后缀配置
        materialNameSuffixOptions: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        nameValidator: {
            type: definePropType(Function)
        },
        // 是否批量推送
        batch: Boolean,
        apps: definePropType([
            Promise,
            Object
        ]),
        business: {
            type: definePropType(String),
            required: true
        }
    },
    components: {
        ChannelSetting: ChannelSetting,
        PackageSetting: PackageSetting,
        PackageManager: PackageManager,
        PlayableName: PlayableName,
        VersionName: VersionName
    },
    setup: function setup(props, param1) {
        var emit = param1.emit;
        var handleDialogClose = function handleDialogClose() {
            emit("update:visible", false);
            emit("close");
        };
        var goSetting = function goSetting() {
            locationToPointManagement();
        };
        var handleAccountChange = function handleAccountChange(value) {
            selectedNodes.value = value;
        };
        var handleXmpChannelIds = function handleXmpChannelIds(value) {
            xmpPushChannelIds.value = value;
        };
        var pack = // 参考packChannelList
        function pack(channel, repack) {
            var postData = {
                project_id: (Array.isArray(props.objectIds) ? props.objectIds : [
                    props.objectIds
                ]).toString(),
                channel_id: channel,
                quality: quality.value
            };
            var packChannel = channelsMap.value[channel];
            if (repack) {
                packChannel.packed = false;
                packChannel.result = undefined;
            }
            if (packChannel.packed) return;
            if (packChannel.loading) return;
            if (!props.packRequest) return;
            packChannel.loading = true;
            props.packRequest(postData).then(function() {
                var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(data) {
                    var limits, size, _max_size, max, results;
                    return regeneratorRuntime.wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return trafficLimits;
                            case 2:
                                limits = _ctx.sent;
                                _ctx.next = 5;
                                return getPackageSizeByChannel(channel, data.list[0]);
                            case 5:
                                size = _ctx.sent;
                                ;
                                max = (_max_size = limits[channel].max_size) !== null && _max_size !== void 0 ? _max_size : 0;
                                packChannel.size = size;
                                packChannel.max = max;
                                packChannel.result = data.list || [];
                                results = Object.values(channelsMap.value).reduce(function(list, next) {
                                    return list.concat(next.result || []);
                                }, []);
                                previewUrl.value = getPreviewUrl(results);
                                if (repack) {
                                    root.$emit("repack", quality.value);
                                }
                            case 14:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function(data) {
                    return _ref.apply(this, arguments);
                };
            }()).catch(function() {
                packChannel.size = 0;
                packChannel.max = 0;
            }).finally(function() {
                packChannel.loading = false;
                packChannel.packed = true;
            });
        };
        var isPackError = // 判段是否打包失败
        // 打包失败：已经打包过了，却没有结果，判定失败
        function isPackError(channel) {
            return Boolean(channel.packed && (!channel.result || channel.result.length === 0));
        };
        var updateQuality = function updateQuality(value) {
            quality.value = value;
            // 重新打包(打包过程不允许重新打包，得等待之前完成了才能操作)
            selectedChannelIds.value.forEach(function(channel) {
                pack(channel, true);
            });
        };
        var getPreviewUrl = function getPreviewUrl(packedList) {
            var _$ref;
            var m = packedList.find(function(item) {
                return item.channel_id === Mintegral;
            });
            if (m) {
                return m.html_url;
            }
            return (_$ref = packedList[0]) === null || _$ref === void 0 ? void 0 : _$ref.html_url;
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var loading = ref(false);
        var trafficLimits = getCommonConfig({
            names: "traffic_limits"
        }).then(function(res) {
            return res.data.data.traffic_limits;
        });
        var previewUrl = ref();
        // 是否超过下载限制
        var overDownloadLimit = ref(false);
        var quality = ref("0,0,0");
        var _obj;
        // @ts-ignore
        var defaultChannelsMap = reactive((_obj = {}, _defineProperty(_obj, Mintegral, {
            loading: false,
            size: 0,
            max: 0,
            result: [],
            packed: false
        }), _defineProperty(_obj, Unity, {
            loading: false,
            size: 0,
            max: 0,
            result: [],
            packed: false
        }), _defineProperty(_obj, Applovin, {
            loading: false,
            size: 0,
            max: 0,
            result: [],
            packed: false
        }), _defineProperty(_obj, IronSource, {
            loading: false,
            size: 0,
            max: 0,
            result: [],
            packed: false
        }), _obj));
        // 已经选中的xmp打包渠道
        var xmpPushChannelIds = ref([]);
        // 已经选中的节点
        var selectedNodes = ref([]);
        // 已经选中的渠道
        var selectedChannelIds = computed(function() {
            return selectedNodes.value.map(function(node) {
                var _$ref;
                return node.value === Xmp ? (_$ref = node.excessChildren) === null || _$ref === void 0 ? void 0 : _$ref.map(function(x) {
                    return x.value;
                }) : node.value;
            }).flat();
        });
        var formValue = reactive({
            from: MaterialMakeFrom.Playsmart,
            batch: [],
            quality: quality.value,
            name: ""
        });
        var channelsMap = computed(function() {
            if (xmpPushChannelIds.value.length) {
                xmpPushChannelIds.value.forEach(function(channel) {
                    // 追加xmp平台的打包渠道
                    // @ts-ignore
                    if (!defaultChannelsMap[channel]) {
                        // @ts-ignore
                        defaultChannelsMap[channel] = reactive({
                            loading: false,
                            max: 0,
                            packed: false,
                            result: [],
                            size: 0
                        });
                    }
                });
            }
            return defaultChannelsMap;
        });
        // 是否有打包失败
        var hasPackedError = computed(function() {
            return selectedChannelIds.value.some(function(id) {
                return isPackError(channelsMap.value[id]);
            });
        });
        // 打包中
        var isPacking = computed(function() {
            return selectedChannelIds.value.some(function(id) {
                return channelsMap.value[id].loading;
            });
        });
        // 是否需要检查包体大小
        var needCheckSize = computed(function() {
            return Boolean(props.packRequest);
        });
        // 选中的渠道打包体积是否超出限制
        var isOversize = computed(function() {
            // 如果不需要检查包体大小，直接返回false
            if (!needCheckSize.value) return false;
            return selectedChannelIds.value.some(function(id) {
                return channelsMap.value[id] && channelsMap.value[id].size > channelsMap.value[id].max;
            });
        });
        // 标记渠道对应的状态
        var channels1 = computed(function() {
            return Object.entries(channelsMap.value).map(function(param) {
                var _param = _slicedToArray(param, 2), k = _param[0], v = _param[1];
                return _objectSpreadProps(_objectSpread({}, v), {
                    name: k
                });
            });
        });
        // 是否可以推送？？？
        var isPushable = computed(function() {
            // xmp平台
            var platform = selectedNodes.value.find(function(x) {
                return x.value === Xmp;
            });
            var xmpUser = platform && platform.children && platform.children.find(function(s) {
                return s.xmp_user_id;
            });
            if (platform) {
                // 可玩项目-xmp平台未选择打包渠道和文件夹, 不允许推送
                if (props.business !== PtBusinessType.Video) {
                    if (xmpPushChannelIds.value.length === 0 || !xmpUser) {
                        return false;
                    }
                } else {
                    // 视频项目-xmp平台未选择文件夹, 不允许推送
                    if (xmpUser) return true;
                }
            }
            // 未选择渠道，不允许推送
            if (selectedChannelIds.value.length === 0) {
                return false;
            }
            // 超出下载限制，不允许推送
            if (overDownloadLimit.value) return false;
            // 已经选中的渠道，打包中 或者 超出打包体积限制，不允许推送
            if (isPacking.value || isOversize.value) return false;
            if (hasPackedError.value) return false;
            return true;
        });
        // 选中的渠道发生变化，打包
        watch(function() {
            return selectedChannelIds.value;
        }, function() {
            selectedChannelIds.value.forEach(function(channel) {
                pack(channel);
            });
        }, {
            deep: true
        });
        function handlePush() {
            return _handlePush.apply(this, arguments);
        }
        function _handlePush() {
            _handlePush = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var data, batch, name;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!props.onBeforePush) {
                                _ctx.next = 6;
                                break;
                            }
                            _ctx.next = 3;
                            return props.onBeforePush(formValue);
                        case 3:
                            _ctx.t0 = _ctx.sent;
                            _ctx.next = 7;
                            break;
                        case 6:
                            _ctx.t0 = formValue;
                        case 7:
                            data = _ctx.t0;
                            batch = selectedNodes.value.map(function(channel) {
                                var push_accounts = [];
                                if (channel.value === Mintegral) {
                                    var _$ref11;
                                    var _$ref1;
                                    push_accounts = (_$ref1 = (_$ref11 = channel.children) === null || _$ref11 === void 0 ? void 0 : _$ref11.reduce(function(accounts, node) {
                                        var _accounts;
                                        var _$ref;
                                        accounts.push({
                                            account_id: node.value
                                        });
                                        var children = (_$ref = node.children) === null || _$ref === void 0 ? void 0 : _$ref.map(function(childNode) {
                                            return {
                                                account_id: childNode.value
                                            };
                                        });
                                        (_accounts = accounts).push.apply(_accounts, _toConsumableArray(children !== null && children !== void 0 ? children : []));
                                        return accounts;
                                    }, [])) !== null && _$ref1 !== void 0 ? _$ref1 : [];
                                } else if (channel.value === Unity) {
                                    var _$ref2;
                                    var _$ref3;
                                    push_accounts = (_$ref3 = (_$ref2 = channel.children) === null || _$ref2 === void 0 ? void 0 : _$ref2.map(function(node) {
                                        var _$ref;
                                        return {
                                            account_id: node.value,
                                            app_ids: (_$ref = node.children) === null || _$ref === void 0 ? void 0 : _$ref.map(function(childNode) {
                                                return childNode.value;
                                            })
                                        };
                                    })) !== null && _$ref3 !== void 0 ? _$ref3 : [];
                                } else if (channel.value === IronSource) {
                                    var _$ref4;
                                    var _$ref5;
                                    push_accounts = (_$ref5 = (_$ref4 = channel.children) === null || _$ref4 === void 0 ? void 0 : _$ref4.map(function(node) {
                                        var _$ref;
                                        return {
                                            account_id: node.value,
                                            app_ids: (_$ref = node.children) === null || _$ref === void 0 ? void 0 : _$ref.map(function(childNode) {
                                                return childNode.value;
                                            })
                                        };
                                    })) !== null && _$ref5 !== void 0 ? _$ref5 : [];
                                } else if (channel.value === Applovin) {
                                    var _$ref6;
                                    var _$ref7;
                                    push_accounts = (_$ref7 = (_$ref6 = channel.children) === null || _$ref6 === void 0 ? void 0 : _$ref6.map(function(node) {
                                        var _$ref;
                                        return {
                                            account_id: node.value,
                                            creative_set_ids: (_$ref = node.children) === null || _$ref === void 0 ? void 0 : _$ref.map(function(childNode) {
                                                return childNode.value;
                                            })
                                        };
                                    })) !== null && _$ref7 !== void 0 ? _$ref7 : [];
                                } else if (channel.value === Xmp) {
                                    var _$ref8;
                                    var xmpUserList = (_$ref8 = channel.children) === null || _$ref8 === void 0 ? void 0 : _$ref8.filter(function(x) {
                                        return x.xmp_user_id;
                                    });
                                    var _$ref9;
                                    push_accounts = (_$ref9 = xmpUserList === null || xmpUserList === void 0 ? void 0 : xmpUserList.map(function(node) {
                                        var _$ref, _$ref13;
                                        return {
                                            account_id: node.value,
                                            folder_id: (_$ref = node.children[0]) === null || _$ref === void 0 ? void 0 : _$ref.value,
                                            folder_name: (_$ref13 = node.children[0]) === null || _$ref13 === void 0 ? void 0 : _$ref13.label
                                        };
                                    })) !== null && _$ref9 !== void 0 ? _$ref9 : [];
                                }
                                if (channel.value === Xmp) {
                                    var _$ref10;
                                    if (props.business === PtBusinessType.Video) {
                                        return {
                                            push_accounts: push_accounts,
                                            platform_name: channel.value
                                        };
                                    }
                                    return {
                                        push_accounts: push_accounts,
                                        platform_name: channel.value,
                                        traffic_types: (_$ref10 = channel.excessChildren) === null || _$ref10 === void 0 ? void 0 : _$ref10.map(function(x) {
                                            return x.value;
                                        })
                                    };
                                }
                                return {
                                    push_accounts: push_accounts,
                                    traffic_type: channel.value
                                };
                            });
                            loading.value = true;
                            name = !props.isPlayablePush ? formValue.name : props.mwsName;
                            pushCreative(_objectSpreadProps(_objectSpread({}, data), {
                                quality: quality.value,
                                batch: batch,
                                name: name
                            })).then(function(res) {
                                handleDialogClose();
                                Message.success(data.from === MaterialMakeFrom.Custom ? root.$t("playTurbo.common.pushDialog.pushSuccess").toString() : root.$t("playTurbo.common.pushDialog.pushSuccessA").toString());
                                // 操作Ir的可玩素材「推送」后，Toast提示“Ironsource会对可玩素材进行检测和审核，需2小时左右能够查看最终推送情况”
                                if (selectedNodes.value.some(function(channel) {
                                    return channel.value === IronSource;
                                })) {
                                    nextTick(function() {
                                        Message.info("Ironsource\u4F1A\u5BF9\u53EF\u73A9\u7D20\u6750\u8FDB\u884C\u68C0\u6D4B\u548C\u5BA1\u6838\uFF0C\u97002\u5C0F\u65F6\u5DE6\u53F3\u80FD\u591F\u67E5\u770B\u6700\u7EC8\u63A8\u9001\u60C5\u51B5");
                                    });
                                }
                                root.$emit("repack", quality.value);
                                emit("push-success");
                            }).finally(function() {
                                loading.value = false;
                            });
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _handlePush.apply(this, arguments);
        }
        function getPackageSizeByChannel(channelId, packedChannel) {
            return _getPackageSizeByChannel.apply(this, arguments);
        }
        function _getPackageSizeByChannel() {
            _getPackageSizeByChannel = _asyncToGenerator(regeneratorRuntime.mark(function _callee(channelId, packedChannel) {
                var _$ref, packageLimit, fileKey, channels;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            _ctx.next = 3;
                            return trafficLimits;
                        case 3:
                            packageLimit = _ctx.sent;
                            fileKey = ((_$ref = packageLimit[channelId]) === null || _$ref === void 0 ? void 0 : _$ref.check_html) ? "html_size" : "file_size";
                            if (!(channelId === Mintegral)) {
                                _ctx.next = 14;
                                break;
                            }
                            channels = packedChannel.extends;
                            if (!(channels.length === 1)) {
                                _ctx.next = 11;
                                break;
                            }
                            return _ctx.abrupt("return", channels[0][fileKey]);
                        case 11:
                            if (!(channels.length > 1 && channels[0][fileKey] > channels[1][fileKey])) {
                                _ctx.next = 13;
                                break;
                            }
                            return _ctx.abrupt("return", channels[0][fileKey]);
                        case 13:
                            return _ctx.abrupt("return", channels[1][fileKey]);
                        case 14:
                            return _ctx.abrupt("return", packedChannel[fileKey]);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _getPackageSizeByChannel.apply(this, arguments);
        }
        return {
            needCheckSize: needCheckSize,
            loading: loading,
            isPushable: isPushable,
            isPacking: isPacking,
            previewUrl: previewUrl,
            channelsMap: channelsMap,
            selectedChannelIds: selectedChannelIds,
            overDownloadLimit: overDownloadLimit,
            quality: quality,
            channels: channels1,
            formValue: formValue,
            updateQuality: updateQuality,
            handleDialogClose: handleDialogClose,
            handlePush: handlePush,
            handleAccountChange: handleAccountChange,
            handleXmpChannelIds: handleXmpChannelIds,
            fmtSize: fmtSize,
            pack: pack,
            isPackError: isPackError,
            goSetting: goSetting
        };
    }
});
